/**
 * Header component with Mainstay branding and user info
 */

import { Header as BloxHeader } from '@ox/blox';
import { useAuth } from '@ox/visits-ui/context/AuthContext';

export function Header() {
  const { isAuthenticated, userData } = useAuth();

  return (
    <BloxHeader name="Visits" type="external">
      {isAuthenticated && userData && (
        <div className="header-user">
          <div className="user-info">
            <span className="user-name">{userData.first_name}</span>
            <span className="user-email">{userData.user_email}</span>
            <span className="property-address">{userData.property_address}</span>
          </div>
        </div>
      )}
    </BloxHeader>
  );
}
